var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdInfoIcon = function SvgAdInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "AdInfoIcon_svg__a",
    d: "M13 16h1a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2h1v-4h-1a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v5zm6.071 3.071c-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142zM6.343 6.343a8 8 0 1 0 11.314 11.314A8 8 0 0 0 6.343 6.343zM11 7.5a1 1 0 0 1 2 0V8a1 1 0 0 1-2 0v-.5z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#57707c",
    href: "#AdInfoIcon_svg__a"
  })));
};
export default SvgAdInfoIcon;